"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderActivityStatus;

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _react = require("react");

var _useGroupTimestamp3 = _interopRequireDefault(require("./useGroupTimestamp"));

var _useSendTimeoutForActivity = _interopRequireDefault(require("./useSendTimeoutForActivity"));

var _useTimePassed = _interopRequireDefault(require("./internal/useTimePassed"));

var _WebChatUIContext = _interopRequireDefault(require("../WebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _Constants$ActivityCl = _botframeworkWebchatCore.Constants.ActivityClientState,
    SEND_FAILED = _Constants$ActivityCl.SEND_FAILED,
    SENDING = _Constants$ActivityCl.SENDING,
    SENT = _Constants$ActivityCl.SENT;

function shouldGroupTimestamp(activityX, activityY, groupTimestamp) {
  if (groupTimestamp === false) {
    // Hide timestamp for all activities.
    return true;
  } else if (activityX && activityY && activityX.from && activityY.from) {
    groupTimestamp = typeof groupTimestamp === 'number' ? groupTimestamp : Infinity;

    if (activityX.from.role === activityY.from.role) {
      var timeX = new Date(activityX.timestamp).getTime();
      var timeY = new Date(activityY.timestamp).getTime();
      return Math.abs(timeX - timeY) <= groupTimestamp;
    }
  }

  return false;
}

function useRenderActivityStatus(_ref) {
  var activity = _ref.activity,
      nextVisibleActivity = _ref.nextVisibleActivity;

  var _useContext = (0, _react.useContext)(_WebChatUIContext.default),
      activityStatusRenderer = _useContext.activityStatusRenderer;

  var _useGroupTimestamp = (0, _useGroupTimestamp3.default)(),
      _useGroupTimestamp2 = _slicedToArray(_useGroupTimestamp, 1),
      groupTimestamp = _useGroupTimestamp2[0];

  var sendTimeout = (0, _useSendTimeoutForActivity.default)(activity);
  var sameTimestampGroup = (0, _react.useMemo)(function () {
    return shouldGroupTimestamp(activity, nextVisibleActivity, groupTimestamp);
  }, [activity, groupTimestamp, nextVisibleActivity]); // SEND_FAILED from the activity is ignored, and is instead based on styleOptions.sendTimeout.
  // Note that the derived state is time-sensitive. The useTimePassed() hook is used to make sure it changes over time.

  var _activity$channelData = activity.channelData;
  _activity$channelData = _activity$channelData === void 0 ? {} : _activity$channelData;
  var _activity$channelData2 = _activity$channelData.clientTimestamp,
      clientTimestamp = _activity$channelData2 === void 0 ? 0 : _activity$channelData2,
      state = _activity$channelData.state,
      role = activity.from.role;
  var fromUser = role === 'user';
  var activitySent = state !== SENDING && state !== SEND_FAILED;
  var pastTimeout = (0, _useTimePassed.default)(fromUser && !activitySent ? new Date(clientTimestamp).getTime() + sendTimeout : 0);
  var sendState = activitySent || !fromUser ? SENT : pastTimeout ? SEND_FAILED : SENDING;
  return (0, _react.useCallback)(function () {
    return activityStatusRenderer({
      activity: activity,
      nextVisibleActivity: nextVisibleActivity,
      sameTimestampGroup: sameTimestampGroup,
      sendState: sendState
    });
  }, [activity, activityStatusRenderer, nextVisibleActivity, sameTimestampGroup, sendState]);
}